<!-- 考核记录 -->
<template>
  <div class="fuzzy-matching-box">
    <div class="fuzzy-matching-top">
      <el-row class="top-first-line ">
        <el-col :span="5">
          <el-form-item label="考核对象:">
            <el-select v-model="Dform.checkUserType" filterable placeholder="请选择" @change="changeBtn">
              <el-option v-for="item in PeopleObj" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5" v-if="Dform.checkUserType != ''">
          <el-form-item label="任务名称:">
            <el-select v-model="Dform.name" filterable placeholder="请选择"  @change="changeName">
              <el-option v-for="item in taskName" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5" v-if="Dform.name != ''">
          <el-form-item label="考核项:">
           <el-select v-model="Dform.checkItemId" filterable placeholder="请选择"  @change="changeName">
              <el-option v-for="item in detailData" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>         
        <el-col :span="5" v-if="Dform.checkUserType != ''">
          <el-form-item label="姓名:">
            <el-input v-model="Dform.checkUserName" placeholder='请输入任务名称搜索'></el-input>
          </el-form-item>
        </el-col>


      </el-row>

      <el-row class="top-first-line the-second-line">

        <el-col :span="5" v-if="Dform.checkUserType == 'student'">
          <el-form-item label="班级:">
            <!-- <el-cascader  ref="catalogue" :show-all-levels="false" :props="propsData"
              :visible="isPopupVisible"
              @visible-change="handleVisibleChange"  :options="options"
              @change="cascaderClick" /> -->
           <el-cascader :props="props" :show-all-levels="false"  @change="cascaderClick"></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="5" v-if="Dform.checkUserType != ''">
          <el-form-item label="开始时间:">
            <el-date-picker v-model="Dform.startTime" type="datetime" format="YYYY-MM-DD HH:mm:ss"
              value-format="YYYY-MM-DD HH:mm:ss" placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="5" v-if="Dform.checkUserType != ''">
          <el-form-item label="结束时间:">
            <el-date-picker v-model="Dform.terminalTime" type="datetime" format="YYYY-MM-DD HH:mm:ss"
              value-format="YYYY-MM-DD HH:mm:ss" placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
        </el-col>


        <el-button type="primary" size="medium" style="margin-left: 40px" @click="QueryBtn">查询</el-button>
        <el-button type="primary" size="medium" style="margin-left: 40px" @click="ExcelBtn">下载Excel</el-button>
      </el-row>


    </div>
    <div class="fuzzy-matching-bottom">
      <el-row class="list">
        <el-table stripe :border="true" :header-cell-style="{ background: '#EDF6FF', color: '#000', }"
          ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" v-loading="loading"
          @selection-change="handleSelectionChange">

          <!-- <el-table-column prop="id" label="ID">
          </el-table-column> -->
          <el-table-column prop="checkItemName" label='项目名称'>
          </el-table-column>
          <el-table-column prop="checkItemName" label="考核分类">
          </el-table-column>
          <el-table-column prop="scoreStandard" label="考核明细">
          </el-table-column>
          <el-table-column prop="checkUserName" label="考核对象">
          </el-table-column>
          <!-- 学生才显示班级 -->
          <el-table-column v-if="Dform.checkUserType=='student'" prop="className" label='班级'>
          </el-table-column>
          <el-table-column prop="memberName" label="考核人">
          </el-table-column>
          <el-table-column prop="created" label="考核时间">
          </el-table-column>
          <el-table-column prop="score" label="分数">
          </el-table-column>
          <el-table-column prop="comment" label='备注'>
          </el-table-column>
          <el-table-column label="操作" min-width="100">
            <template #default="scope">
              <el-button type="text" class="lookClass" size="small" @click="affirmBtn(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="block-fenye">
          <el-pagination :small="small" :disabled="disabled" :background="background" layout="prev, pager, next, jumper"
            :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import { GetTaskList ,CheckTaskList,recordTaskList,getDeletCheckTask,RecordExportTask } from '@/assets/api/deyu.js';
import { getGradeList, getFindClassList } from '@/assets/api/renyuan';
import { findTeacherInfo } from '@/assets/api/renyuan';
import { ElMessage } from 'element-plus'

export default {
  components: {
  },
  data() {
    return {
      loading: false,
      tongjiObj: {},
      Dform: {
        checkUserType: "",
        name: '',
        startTime: "",
        terminalTime: "",
        checkUserName: '',
        floor: '',
        checkItemId:''
      },
      tableData: [],
      taskName: [],
      detailData:[],
      checkUser: '',
      pageInfo: {
        page: 1,
        pageSize: 999,
      },
      total: 0,
      PeopleObj: [
        {
          value: 'student',
          label: '学生'
        },
        {
          value: 'class',
          label: '班级'
        },
        {
          value: 'teacher',
          label: '教师'
        },
      ],
      options: [],
      isPopupVisible: false,
      propsData: {
        value: 'id',
        label: 'name',
        children: 'children'
      },
      props: {
       lazy: true,
       lazyLoad:async(node, resolve) => {
         const {
           level
         } = node;
         let data
         if (level) {
           data =  await this.classClick(level,node.data)
         }
         console.log('data',data);
         setTimeout(() => {
           let nodes
           nodes = level ? data : this.options
           console.log('nodes',nodes);
           resolve(nodes);
         }, 1000);
       },
       value: 'id',
       label: 'name',
       children: 'children'
     },
      teacherObj: {}
    };
  },
  created() {
    this.Lookteacher()
  },
  mounted() {
  },
  methods: {
    Lookteacher() {
      let params = {
        userId: JSON.parse(localStorage.getItem('user')).id,
      }
      findTeacherInfo(params).then((res) => {
        console.log(res, '查看权限');
        this.teacherObj = res.data.data
        if (this.teacherObj.schoolId && this.teacherObj.schoolId != '' && this.teacherObj.schoolId != null) {
          this.schoolClick()
        }
      }).catch((err) => {
        console.log(err);
      })
    },
    schoolClick() {
      let params = {
        page: '1',
        pageSize: '999',
      }
      getGradeList(params, this.teacherObj.schoolId).then((res) => {
        console.log(res, '年级列表');
        this.options = res.data.data;
        for (let val of this.options) {
          val.sln_type = '年级'
          val.childrenShow = false
        }
      }).catch((err) => {
        console.log(err);
      })
    },
    classClick(level,item) {
      let params = {
        page: '1',
        pageSize: '999',
      }
      return new Promise((resolve)=> {
       getFindClassList(params, item.id).then((res) => {
         console.log(res.data.data.list, '班级列表');
         for (let val of res.data.data.list) {
           val.leaf = level >= 1
         }
         resolve(res.data.data.list)
       }).catch((err) => {
         console.log(err);
       })
     })
    },
    cascaderClick(value) {
     this.Dform.floor = value[value.length - 1]
     console.log(value, '联机', this.Dform.floor);
    },
    changeBtn() {
     this.getTaskName()
    },
    QueryBtn() {
      this.GetrecordTaskList()
    },
    //掉看考核明细
    changeName(){
     this.getKaoheMingxi()
    },
    //查看考核明细
    getKaoheMingxi(){
     CheckTaskList(this.Dform.name).then(res=> {
        this.detailData = res.data.data    
     })
    },

    //确认删除
    affirmBtn(row){
     this.$confirm('确定删除该任务记录?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
      }).then(() => {
          this.deleteBtn(row)
      }).catch((err) => {
          this.$message({
              type: 'error',
              message: err.response.data.msg
          });
      });

   },
    //删除
    deleteBtn(row){
     // console.log(row);
     getDeletCheckTask(row.id).then(res =>{
        this.GetrecordTaskList()
        ElMessage({message: '删除成功',type: 'success',})
     })
     
    },
    //统计导出
    ExcelBtn() {
      const params = {
        checkUserType: this.Dform.checkUserType,
        checkUserName: this.Dform.checkUserName,
        checkTaskId: this.Dform.name,
        startTime: this.Dform.startTime,
        endTime: this.Dform.terminalTime,
        page: this.pageInfo.page,
        pageSize: this.pageInfo.pageSize,
        loginUserId: JSON.parse(localStorage.getItem('user')).id,
        classId:this.Dform.floor,
        checkItemId:this.Dform.checkItemId,
        schoolId:this.teacherObj.schoolId,



      }
      RecordExportTask(params).then(res => {
        this.handleExport(res.data, '任务记录导出.xls')
        ElMessage({ message: '任务记录导出成功', type: 'success', })

      }).catch((err) => {
        // console.log(err);
        this.$message({
          type: 'error',
          message: err.response.data.msg
        });

      })
    },
    //任务记录列表
    GetrecordTaskList() {
     this.loading = true
      const params = {
        checkUserType: this.Dform.checkUserType,
        checkUserName: this.Dform.checkUserName,
        checkTaskId: this.Dform.name,
        startTime: this.Dform.startTime,
        endTime: this.Dform.terminalTime,
        page: this.pageInfo.page,
        pageSize: this.pageInfo.pageSize,
        loginUserId: JSON.parse(localStorage.getItem('user')).id,
        classId:this.Dform.floor,
        checkItemId:this.Dform.checkItemId,
        schoolId:this.teacherObj.schoolId,
        
      }
      recordTaskList(params).then((res) => {
        console.log(res.data.data, '任务记录查询');
        this.loading = false
        this.tableData = res.data.data.list

      }).catch((err) => {
        console.log(err);

      })
    },
    //获取任务名称下拉列表
    getTaskName() {
      const params = {
        checkUserType: this.Dform.checkUserType,
        page: this.pageInfo.page,
        pageSize: this.pageInfo.pageSize,
        userId: JSON.parse(localStorage.getItem('user')).id,
      }
      GetTaskList(params).then((res) => {
        this.taskName = res.data.data.list
        console.log(res, '任务名称');
      }).catch((err) => {
        console.log(err);
      })
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val
      this.GetrecordTaskList()
    },
  //   导出
    handleExport(data, name) {
      // 动态创建iframe下载文件
      let fileName = name;
      if (!data) {
        return;
      }
      let blob = new Blob([data], { type: "application/octet-stream" });
      console.log(blob);
      if ("download" in document.createElement("a")) {
        // 不是IE浏览器
        let url = window.URL.createObjectURL(blob);
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // 下载完成移除元素
        window.URL.revokeObjectURL(url); // 释放掉blob对象
      } else {
        // IE 10+
        window.navigator.msSaveBlob(blob, fileName);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.fuzzy-matching-box {
  padding-top: 35px;
  // overflow: hidden;
  // overflow: auto;
  width: 100%;
  height: 96%;
  background-color: #fff;
  border-radius: 8px;

  .fuzzy-matching-top {

    .the-second-line {
      margin-top: 20px;
    }

    .top-first-line {

      //  justify-content: space-around;

      /deep/ {
        .el-select--small .el-select__wrapper {
          height: 35px;
        }

        .el-form-item--small .el-form-item__label {
          // background-color: red;
          font-size: 16px;
        }

        .el-form-item--small .el-form-item__label {
          width: 110px;
          text-align: right;
          height: 35px;
          line-height: 35px;
        }

        .el-input {
          width: 100%;
          height: 35px;
        }
        .el-cascader--small {
          width: 100%;
        }
        .el-select .el-input__wrapper{
          width: 220px;
        }

      }
    }

  }

  .fuzzy-matching-bottom {
    height: calc(100% - 170px);
    // overflow: auto;
    // position: relative;
    padding: 0px 20px;
    padding-top: 20px;
    background-color: #fff;
    border-radius: 8px;

    .lookClass {
      font-size: 15px;
      font-weight: 700;
    }


    .list {
      position: relative;
      padding-bottom: 50px;

      .fenye {
        // float: right;
        text-align: center;
      }

      /deep/ {
        .el-table td.el-table__cell,
        .el-table th.el-table__cell.is-leaf {
          // border: 0px;
        }

        .el-table tr {
          height: 40px;
          cursor: pointer;
          // user-select: none;
          font-size: 16px;
          color: black;
        }

        .confirm,
        .duplicate,
        .revise {
          color: #1677FF;

        }

        .el-table th.el-table__cell>.cell {
          text-align: center;
          font-size: 16px;
          font-weight: 700;
        }

        .el-table td.el-table__cell,
        .fuzzy-matching-box .fuzzy-matching-bottom .list[data-v-1ddf37d1] .el-table th.el-table__cell.is-leaf {
          text-align: center;
        }
      }

      .block-fenye {
        // float: right;
        position: absolute;
        bottom: 0px;
        left: 50%;
        transform: translate(-50%, 0);

      }
    }
  }
}
</style>